import React, { useEffect } from 'react';
import { useHEREMap } from '@tenderd/track-web-utils';
var IdlingHeatMapCard = function (_a) {
    var data = _a.data;
    var map = useHEREMap().map;
    useEffect(function () {
        if (data && data.length > 0 && map) {
            map.setCenter({
                lat: data[0][0],
                lng: data[0][1],
            });
            map.setZoom(15);
            var heatmapProvider = new H.data.heatmap.Provider({
                colors: new H.data.heatmap.Colors({
                    '0': 'blue',
                    '0.5': 'yellow',
                    '1': 'red',
                }, true),
            });
            heatmapProvider.addData(data.map(function (coord) { return new H.geo.Point(coord[0], coord[1]); }));
            var heatmapLayer = new H.map.layer.TileLayer(heatmapProvider);
            map.addLayer(heatmapLayer);
        }
    }, [data]);
    return React.createElement(React.Fragment, null);
};
export default IdlingHeatMapCard;
